<template>
    <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important">       
                <v-text-field v-model="props.search" class="px-2 pt-0" append-icon="search" :label="$t('on_premises.search')" single-line hide-details></v-text-field>
                <span v-for="data in this.filteredArray" :key="data.idN">
                    <v-col cols="6" class="px-0 py-0" style="display:inline-block !important">
                        <v-card class="mx-2 mt-4 px-3 py-2" :to="'/operation/place-on-ramp/' + data.id + '/' + from + '/' + m_type" style="font-size:13px;" cols="6">
                            <div class="decoration_pendings"></div>
                            <v-col class="px-2 mx-0" cols="12" md="12" align="start">
                                <v-row>
                                    <v-col class="py-0 px-0" style="color:#239791; font-weight: bold !important;" md="12"><span class="pr-1 secondary--text"></span> {{ data.client.name }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" class="px-4 mx-0">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{ $t('operation.appointment') }}: </span> {{ data.id }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{ $t('operation.container') }}: </span> {{ data.container_number }}
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">
                                            {{ $t('operation.schedule') }}: </span> 
                                            {{ data.arrival_date.substring(0,10) }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{ $t('operation.movement_type') }}: </span>
                                            <span v-if="$store.state.language == 'es'">{{ data.operation.description }}</span>
                                            <span v-if="$store.state.language == 'en'">{{ data.operation.description1 }}</span>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-card>
                    </v-col>
                </span>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { appointmentOperationIndexUseCase } from '../../application/use_cases/appointment_operation_index_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';

export default {
  components: { },
    data (){
        return {
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            page: 1,
            pages: 0,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            filteredArray: [],
            props:{
                items: [],
                search: '',
            },
        }
    },
    mounted(){
        localStorage.setItem('bottom', 1);
        this.$store.state.bottom = 1;
        this.$store.state.module = "headers.on_premises_operation";
        this.index();
    },
    methods: {
        handler(i, id){
            if(i == 0) this.edit(id);
        },
        async index(){
            this.props.items = [];
            this.filteredArray = [];

            try{
                this.props.items = await appointmentOperationIndexUseCase('En recinto', this.from, this.m_type, HttpAppointmentRepository);
                this.filteredArray = this.props.items;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    },
    watch: {
        'props.search': function() {
            const sear = this.props.search.toString().toLowerCase();

            if(!sear) { return this.filteredArray = this.props.items; }
            this.filteredArray = this.props.items.filter((x)=> {

                if(x.id != null) if (x.id.toString().toLowerCase().includes(sear)) return x;
                if(x.container_number != null) if (x.container_number.toString().toLowerCase().includes(sear)) return x; 
                if(x.arrival_date != null) if (x.arrival_date.substring(0,10).toString().toLowerCase().includes(sear)) return x;
                if(x.operation != null) if (x.operation.description.toString().toLowerCase().includes(sear)) return x;
                if(x.operation != null) if (x.operation.description1.toString().toLowerCase().includes(sear)) return x;
                if(x.client != null) if (x.client.name.toString().toLowerCase().includes(sear)) return x;
            });
        },
        '$route.params.from': function() {
            location.reload();
        },
        '$route.params.m_type': function() {
            location.reload();
        }
    }
}
</script>

<style lang="css">
.decoration_pendings{
    background-color: #239791;
    height: 100%;
    width: 10px;
    position:absolute;
    padding: 0;
    margin: 0;
    border-top-left-radius: 5px !important;
    border-top-right-radius: 0px !important;
    border-bottom-left-radius: 5px !important;
    left:-2px;
    top: 0;
}
.size{
    min-height: calc(100vh - 120px) !important;
    position:relative !important;
}
</style>